import { graphql, Link, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';
import { PostLatestNewsQuery } from '../../../graphql-generated';
import { isNotNull } from '../../../utils/isNotNull';
import { parseLink } from '../../../utils/parseLink';
import './postLatestNews.scss';

export const PostLatestNews: React.FC<any> = ({}) => {
  const data = useStaticQuery<PostLatestNewsQuery>(query);

  const latestNews = data.wp?.options?.acfLatestNews?.postPageLatestNews?.postPageLatestNews?.filter(
    isNotNull
  );

  return latestNews && latestNews.length > 0 ? (
    <>
      {/* a placeholder used to "move" content down since PostLatestNews is position-fixed now */}
      <div className="post-latest-news-ghost" />
      <div className="post-latest-news">
        <div className="huge-container post-latest-news__wrapper">
          {latestNews.map((news, i) => {
            if (news.__typename !== 'WpPost') return;

            return (
              <Link key={news?.link ?? i} to={parseLink(news?.link)}>
                <span className="post-latest-news-item">
                  {news?.featuredImage?.node?.localFile?.childImageSharp
                    ?.fixed && (
                    <Img
                      fixed={
                        news?.featuredImage?.node?.localFile?.childImageSharp
                          ?.fixed as any
                      }
                      className="post-latest-news-item__image"
                    />
                  )}
                  <div className="inner-wrapper">
                    <div className="post-latest-news-item__title">
                      {news?.title}
                    </div>
                  </div>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  ) : null;
};

const query = graphql`
  query PostLatestNewsQuery {
    wp {
      options {
        acfLatestNews {
          __typename
          fieldGroupName
          postPageLatestNews {
            postPageLatestNews {
              ... on WpPost {
                title
                link
                date
                featuredImage {
                  node {
                    id
                    localFile {
                      childImageSharp {
                        fixed(quality: 80, width: 160, height: 120) {
                          ...TechImageSharpFixed_withWebp
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
